import React, {Component} from 'react';
import axios from '../custom-axios/tvchannels';

import TariffTypes from '../components/main/tariffTypesMain';
import IncludedTvPackages from '../components/main/includedTvPackages';
import AdditionalTvPackages from '../components/main/additionalTvPackages';
import TvChannelsList from '../components/main/tvChannelsList';
import TvChannelsModal from '../components/main/tvChannelsModal';
import TariffChangeModal from '../components/main/tariffChangeModal';
import {TvChannelsContext} from "../context/TvChannelsContext";

const queryString = require('query-string');

class TvChannels extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTariffType: 1414,
            selectedTariffModel: 1439,
            tvPackages: [],
            dvbtTvPackages: [],
            tvChannels: [],
            selectedDisplayTvPackage: null,
            selectedDisplayDVBTTvPackage: null,
            freePackageCount: 0,
            tariffModelContent: null,
            selectedFreeTvPackages: [],
            selectedAdditionalTvPackages: [],
            showTariffChange: false,
            tariffChangeUrlDestination: null,
            showChannels: true,
            fetchingTvPackages: false
        }
    }


    render() {
        return (
            <TvChannelsContext.Provider value={{
                tvPackages: this.state.tvPackages,
                isFreePackageSelectable: (tvPackage) => this.isFreePackageSelectable(tvPackage),
                isAdditionalPackageSelectable: (tvPackage) => this.isAdditionalPackageSelectable(tvPackage),
                location: this.props.location,
                history: this.props.history,
                fetchingTvPackages: this.state.fetchingTvPackages
            }}>
                <TariffTypes tariffTypes={this.props.tariffTypes}
                             tariffModelShortNames={this.props.tariffModelShortNames}
                             updateQueryParams={(key, value) => this.updateQueryParams(key, value)}
                             selectedTariffType={this.state.selectedTariffType}
                             selectedTariffModel={this.state.selectedTariffModel}
                             toggleTariffChangeModal={(url, e) => this.toggleTariffChangeModal(url, e)}
                             cities={this.props.cities}
                             municipalities={this.props.municipalities}
                             selectedCity={this.props.selectedCity}
                             selectedMunicipality={this.props.selectedMunicipality}
                             selectCity={this.selectCity}
                             selectMunicipality={(mun) => this.props.selectMunicipality(mun)}
                             selectedCityName={this.props.selectedCityName}
                             selectedMunicipalityName={this.props.selectedMunicipalityName}
                             autocompleteCities={this.props.autocompleteCities}
                             autocompleteMunicipalities={this.props.autocompleteMunicipalities}
                             setSelectedCityName={(name) => this.props.setSelectedCityName(name)}
                             setSelectedMunicipalityName={(name) => this.props.setSelectedMunicipalityName(name)}
                             lang={this.props.lang}
                             history={this.props.history}
                             showChangeCityBtn={this.props.showChangeCityBtn}
                             municipalityInputRef={this.props.municipalityInputRef}/>

                <IncludedTvPackages tvPackages={this.state.tvPackages['INCLUDED']}
                                    dvbtTvPackages={this.state.dvbtTvPackages['INCLUDED']}
                                    selectDisplayTvPackage={(p) => this.selectDisplayTvPackage(p)}
                                    selectDisplayDVBTTvPackage={(p) => this.selectDisplayDVBTTvPackage(p)}
                                    technologyType={this.props.technologyType}
                                    selectedTariffModel={this.props.selectedTariffModel}
                                    lang={this.props.lang}/>


                <AdditionalTvPackages tvPackages={this.state.tvPackages['ADDITIONAL']}
                                      dvbtTvPackages={this.state.dvbtTvPackages['ADDITIONAL']}
                                      selectDisplayTvPackage={(p) => this.selectDisplayTvPackage(p)}
                                      selectDisplayDVBTTvPackage={(p) => this.selectDisplayDVBTTvPackage(p)}
                                      selectedAdditionalTvPackages={this.state.selectedAdditionalTvPackages}
                                      updateQueryParams={(key, value, remove) => this.updateQueryParams(key, value, remove)}
                                      lang={this.props.lang}
                                      freePackageCount={this.state.freePackageCount}
                                      tariffModelContent={this.state.tariffModelContent}
                                      technologyType={this.props.technologyType}
                />

                <TvChannelsList channels={this.state.tvChannels}
                                tariffTypes={this.props.tariffTypes}
                                tariffModelShortNames={this.props.tariffModelShortNames}
                                selectedTariffType={this.state.selectedTariffType}
                                showChannels={this.state.showChannels}
                                toggleShowChannels={(showChannels) => this.toggleShowChannels(showChannels)}
                                lang={this.props.lang}/>

                <TvChannelsModal package={this.state.selectedDisplayTvPackage}
                                 selectDisplayTvPackage={(p) => this.selectDisplayTvPackage(p)}
                                 lang={this.props.lang}/>

                <TvChannelsModal package={this.state.selectedDisplayDVBTTvPackage}
                                 selectDisplayTvPackage={(p) => this.selectDisplayDVBTTvPackage(p)}
                                 lang={this.props.lang}/>

                <TariffChangeModal showTariffChange={this.state.showTariffChange}
                                   history={this.props.history}
                                   urlDestination={this.state.tariffChangeUrlDestination}
                                   toggleTariffChangeModal={() => this.toggleTariffChangeModal()}
                                   lang={this.props.lang}/>
            </TvChannelsContext.Provider>
        );
    }

    componentDidMount() {
        const params = queryString.parse(this.props.location.search);
        if (this.props.technologyType) {
            if (!this.state.selectedTariffType && params.tariffType) {
                this.selectTariffType(params.tariffType)
            }else{
                this.selectTariffType(1414)
            }

            if (!this.state.selectedTariffModel && params.tariffModel) {
                this.selectTariffModel(params.tariffModel)
            }else{
                this.selectTariffModel(1439)
            }

            if (this.state.selectedFreeTvPackages.length === 0 && params.freePackage) {
                if (Array.isArray(params.freePackage))
                    this.selectFreeTvPackages(params.freePackage.map(fp => parseInt(fp)));
                else
                    this.selectFreeTvPackages([parseInt(params.freePackage)]);
            }

            if (this.state.selectedAdditionalTvPackages.length === 0 && params.additionalPackage) {
                if (Array.isArray(params.additionalPackage))
                    this.selectAdditionalTvPackages(params.additionalPackage.map(fp => parseInt(fp)));
                else
                    this.selectAdditionalTvPackages([parseInt(params.additionalPackage)]);
            }

        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const prevParams = queryString.parse(prevProps.location.search);
        const params = queryString.parse(this.props.location.search);

        if (this.props.technologyType) {
            if ((prevParams.tariffType && params.tariffType && prevParams.tariffType !== params.tariffType) || (prevParams.tariffType && params.tariffType && !this.state.selectedTariffType)) {
                this.selectTariffType(params.tariffType)
            }

            if ((!prevParams.tariffModel && params.tariffModel) ||
                (prevParams.tariffModel && !params.tariffModel) ||
                (prevParams.tariffModel && params.tariffModel && prevParams.tariffModel !== params.tariffModel) ||
                (prevParams.tariffModel && params.tariffModel && !this.state.selectedTariffModel) ||
                (!prevProps.technologyType && params.tariffModel) ||
                prevProps.technologyType && this.props.technologyType && prevProps.technologyType !== this.props.technologyType) {
                this.selectTariffModel(params.tariffModel)
            }

            let freePackagesChange = false;

            if (Array.isArray(params.freePackage)) {
                let previousFreePackagesString = Array.isArray(prevParams.freePackage) ? JSON.stringify(prevParams.freePackage.sort((fp1, fp2) => parseInt(fp1) - parseInt(fp2))) : "";
                let currentFreePackagesString = JSON.stringify(params.freePackage.sort((fp1, fp2) => parseInt(fp1) - parseInt(fp2)));
                let stateFreePackagesString = JSON.stringify(this.state.selectedFreeTvPackages.sort((fp1, fp2) => parseInt(fp1) - parseInt(fp2)));

                freePackagesChange = (currentFreePackagesString !== stateFreePackagesString && currentFreePackagesString !== previousFreePackagesString) || (currentFreePackagesString !== stateFreePackagesString && stateFreePackagesString === "[]");
            }

            if (freePackagesChange) {
                this.selectFreeTvPackages(params.freePackage.map(fp => parseInt(fp)));
            } else if (!Array.isArray(params.freePackage) && params.freePackage) {
                if (this.state.selectedFreeTvPackages.length > 1) {
                    this.selectFreeTvPackages([parseInt(params.freePackage)]);
                } else if (this.state.selectedFreeTvPackages.length === 1 && this.state.selectedFreeTvPackages[0] !== parseInt(params.freePackage)) {
                    this.selectFreeTvPackages([parseInt(params.freePackage)]);
                } else if (!Array.isArray(params.freePackage) && this.state.selectedFreeTvPackages.length === 0) {
                    this.selectFreeTvPackages([parseInt(params.freePackage)]);
                }

            } else if (!params.freePackage) {
                if (this.state.selectedFreeTvPackages.length > 0) {
                    this.removeAllFreeTvPackages();
                }
            }


            let additionalPackagesChange = false;

            if (Array.isArray(params.additionalPackage)) {
                let previousAdditionalPackagesString = Array.isArray(prevParams.additionalPackage) ? JSON.stringify(prevParams.additionalPackage.sort((fp1, fp2) => parseInt(fp1) - parseInt(fp2))) : "";
                let currentAdditionalPackagesString = JSON.stringify(params.additionalPackage.sort((fp1, fp2) => parseInt(fp1) - parseInt(fp2)));
                let stateAdditionalPackagesString = JSON.stringify(this.state.selectedAdditionalTvPackages.sort((fp1, fp2) => parseInt(fp1) - parseInt(fp2)));

                additionalPackagesChange = (currentAdditionalPackagesString !== stateAdditionalPackagesString && currentAdditionalPackagesString !== previousAdditionalPackagesString) || (currentAdditionalPackagesString !== stateAdditionalPackagesString && stateAdditionalPackagesString === "[]");
            }

            if (additionalPackagesChange) {
                this.selectAdditionalTvPackages(params.additionalPackage.map(fp => parseInt(fp)));
            } else if (!Array.isArray(params.additionalPackage) && params.additionalPackage) {
                if (this.state.selectedAdditionalTvPackages.length > 1) {
                    this.selectAdditionalTvPackages([parseInt(params.additionalPackage)]);
                } else if (this.state.selectedAdditionalTvPackages.length === 1 && this.state.selectedAdditionalTvPackages[0] !== parseInt(params.additionalPackage)) {
                    this.selectAdditionalTvPackages([parseInt(params.additionalPackage)]);
                } else if (!Array.isArray(params.additionalPackage) && this.state.selectedAdditionalTvPackages.length === 0) {
                    this.selectAdditionalTvPackages([parseInt(params.additionalPackage)]);
                }

            } else if (!params.additionalPackage) {
                if (this.state.selectedAdditionalTvPackages.length > 0) {
                    this.removeAllAdditionalTvPackages();
                }
            }

            if (prevProps.technologyType !== this.props.technologyType) {
                this.fetchTvChannels()
            }
        }
    }

    selectCity = (cityId) => {
        this.setState({
            tvPackages: [],
            tvChannels: []
        }, () => this.props.selectCity(cityId))
    }

    removeQueryParam(keys) {
        const params = queryString.parse(this.props.location.search);
        keys.forEach(key => delete params[key]);

        let qs = "?";
        Object.keys(params).forEach(key => {
            if (Array.isArray(params[key])) {
                params[key].forEach(p => {
                    qs += `${key}=${p}&`
                })
            } else {
                qs += `${key}=${params[key]}&`
            }
        });

        this.props.history.push({pathname: '/tv-channels', search: `${qs.substring(0, qs.length - 1)}`});
    }


    selectTariffType(tariffType) {
        this.setState({
            selectedTariffType: parseInt(tariffType)
        }, () => {
            this.fetchTvChannels();
        })
    }

    selectTariffModel(tariffModel) {
        this.setState({
            selectedTariffModel: !isNaN(tariffModel) ? parseInt(tariffModel) : -1
        }, () => {
            this.fetchTvPackages();
            this.fetchDVBTTvPackages();
            this.fetchFreePackageCount();
            this.fetchTariffModelContent();
            this.fetchTvChannels();
        })
    }

    selectDisplayTvPackage(p) {
        this.setState({
            selectedDisplayTvPackage: p
        })
    }

    selectDisplayDVBTTvPackage(p) {
        this.setState({
            selectedDisplayDVBTTvPackage: p
        })
    }

    selectFreeTvPackages(packages) {
        this.setState({
            selectedFreeTvPackages: packages
        }, () => this.validateSelectedFreePackages())
    }

    validateSelectedFreePackages() {
        if (this.state.tvPackages && this.state.tvPackages['FREE']) {

            const additionalPackages = this.state.tvPackages && this.state.tvPackages['ADDITIONAL'] ?
                this.state.tvPackages['ADDITIONAL']
                    .filter(p => this.state.selectedAdditionalTvPackages.includes(p.id))
                    .map(p => p.tvPackageId)
                :
                []

            const selectedPackages = [...this.state.selectedFreeTvPackages]
            const validFreePackages = this.state.tvPackages['FREE']
                .filter(p => !additionalPackages.includes(p.tvPackageId))
                .map(p => p.id)

            const invalidSelectedPackages = selectedPackages.filter(p => !validFreePackages.includes(parseInt(p)))

            if (invalidSelectedPackages.length > 0) {
                this.updateQueryParams('freePackage', invalidSelectedPackages, true)
            }
        }
    }

    selectAdditionalTvPackages(packages) {
        this.setState({
            selectedAdditionalTvPackages: packages
        }, () => this.validateSelectedAdditionalPackages())
    }

    validateSelectedAdditionalPackages() {
        if (this.state.tvPackages && this.state.tvPackages['ADDITIONAL']) {
            const freePackages = this.state.tvPackages && this.state.tvPackages['FREE'] ?
                this.state.tvPackages['FREE']
                    .filter(p => this.state.selectedFreeTvPackages.includes(p.id))
                    .map(p => p.tvPackageId)
                :
                []

            const selectedPackages = [...this.state.selectedAdditionalTvPackages]
            const validAdditional = this.state.tvPackages['ADDITIONAL']
                .filter(p => !freePackages.includes(p.tvPackageId))
                .map(p => p.id)

            const invalidSelectedPackages = selectedPackages.filter(p => !validAdditional.includes(parseInt(p)));
            if (invalidSelectedPackages.length > 0) {
                this.updateQueryParams('additionalPackage', invalidSelectedPackages, true)
            }
        }
    }

    toggleShowChannels(showChannels) {
        this.setState({
            showChannels: showChannels
        })
    }

    removeAllFreeTvPackages() {
        this.setState({
            selectedFreeTvPackages: []
        })
    }

    removeAllAdditionalTvPackages() {
        this.setState({
            selectedAdditionalTvPackages: []
        })
    }

    fetchTvPackages() {
        this.setState({
            fetchingTvPackages: true
        }, () => {
            axios.get(`/package/tariff-model/${this.state.selectedTariffModel}?technologyType=${this.props.technologyType}`)
                .then(response => {
                    setTimeout(() => {
                        this.setState({
                            tvPackages: response.data,
                            fetchingTvPackages: false
                        }, () => this.validateSelectedAdditionalPackages())
                    }, 1000)
                })
        })
    }

    fetchDVBTTvPackages(){
        this.setState({
            fetchingTvPackages: true
        }, () => {
            axios.get(`/package/tariff-model/${this.state.selectedTariffModel}?technologyType=DVBT`)
                .then(response => {
                    setTimeout(() => {
                        this.setState({
                            dvbtTvPackages: response.data,
                            fetchingTvPackages: false
                        }, () => this.validateSelectedAdditionalPackages())
                    }, 1000)
                })
        })
    }


    fetchFreePackageCount() {
        axios.get(`/free-packages/${this.state.selectedTariffModel}`)
            .then(response => {
                this.setState({
                    freePackageCount: response.data.max
                }, () => {
                    if (this.state.selectedFreeTvPackages.length > this.state.freePackageCount) {
                        this.selectFreeTvPackages(this.state.selectedFreeTvPackages.slice(0, this.state.freePackageCount))
                    }

                })
            }).catch(error => {
            console.log(error)
        })
    }

    fetchTariffModelContent(){
        axios.get(`/tariff-model/content/${this.state.selectedTariffModel}?language=${this.props.lang}`)
            .then(response => {
                this.setState({
                    tariffModelContent: response.data
                })
            }).catch(error => {
            console.log(error)
        })
    }

    fetchTvChannels() {
        let url = `/channels/tariff-type/${this.state.selectedTariffType}?`
        url = this.state.selectedTariffModel ? `${url}tariffModelId=${this.state.selectedTariffModel}&` : url
        url = this.props.technologyType ? `${url}technologyType=${this.props.technologyType}` : url

        axios.get(url)
            .then(response => {
                this.setState({
                    tvChannels: response.data
                })
            }).catch(error => {
            console.log(error)
        })
    }

    updateQueryParams(key, value, remove) {
        const params = queryString.parse(this.props.location.search);
        if (remove) {
            if (Array.isArray(params[key])) {
                params[key] = params[key].filter(p => p != value);
                if (params[key].length === 0) {
                    delete params[key];
                }
            } else {
                delete params[key];
            }
        } else {
            if (Array.isArray(params[key]))
                params[key].push(value);
            else if (key === 'freePackage' || key === 'additionalPackage') {
                if (params[key]) {
                    let values = [params[key], value];
                    params[key] = values;
                } else params[key] = value;
            } else
                params[key] = value;
        }
        let qs = "?";
        Object.keys(params).forEach(key => {
            if (Array.isArray(params[key])) {
                params[key].forEach(p => {
                    qs += `${key}=${p}&`
                })
            } else {
                qs += `${key}=${params[key]}&`
            }
        });
        this.props.history.push(`/tv-channels${qs.substring(0, qs.length - 1)}`);
    }

    translateName(obj) {
        if (this.props.lang === 'en_US') {
            return obj.nameEN
        } else if (this.props.lang === 'sq_AL') {
            return obj.nameAL
        } else return obj.nameMK
    }

    isAdditionalPackageSelectable(tvPackage) {
        const freePackages = this.state.tvPackages && this.state.tvPackages['FREE'] ?
            this.state.tvPackages['FREE']
                .filter(p => this.state.selectedFreeTvPackages.includes(p.id))
                .map(p => p.tvPackageId)
            :
            []

        const selectedPackages = [...this.state.selectedAdditionalTvPackages]
        const validAdditional = this.state.tvPackages['ADDITIONAL']
            .filter(p => !freePackages.includes(p.tvPackageId))
            .map(p => p.id)

        return validAdditional.includes(tvPackage.id)
    }

    isFreePackageSelectable(tvPackage) {
        const additionalPackages = this.state.tvPackages && this.state.tvPackages['ADDITIONAL'] ?
            this.state.tvPackages['ADDITIONAL']
                .filter(p => this.state.selectedAdditionalTvPackages.includes(p.id))
                .map(p => p.tvPackageId)
            :
            []

        const selectedPackages = [...this.state.selectedFreeTvPackages]
        const validFreePackages = this.state.tvPackages['FREE']
            .filter(p => !additionalPackages.includes(p.tvPackageId))
            .map(p => p.id)

        return this.state.selectedFreeTvPackages.length < this.state.freePackageCount && validFreePackages.includes(tvPackage.id)
    }

}

export default TvChannels;
